import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { partitionFieldsByVisibility } from '../utils/fields';

export default createSelector(
  [(state: RootState) => state.config.oauthExtraFields],
  (
    profileFields,
  ): { all: RegisterFields[]; visible: RegisterFields[]; hidden: RegisterFields[] } => {
    const oauthFields: RegisterFields[] = (profileFields || [])
      .map((field: { inputType: any; registerMode: any }) => ({
        ...field,
        registerMode: undefined,
        editMode: undefined,
        inputType: field.inputType,
        mode: field.registerMode,
      }))
      .filter((field: { mode: string }) => field.mode !== 'disabled');

    return {
      all: oauthFields,
      ...partitionFieldsByVisibility(oauthFields),
    };
  },
);
